<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          Customer Search
        </CCardHeader>
        <CCardBody>
          <div style="width:100%;float:left;text-align: center;padding-bottom:15px;">
            <!-- <label style="width:100%;text-align:center;color:#ccc;">Press Esc to clear search</label> -->
            <!-- <select style="width:250px;margin-left:auto;margin-right:auto;margin-bottom:15px;" v-model="filter" class="form-control" @change="searchCustomer()">
              <option value="Search Customer">Search Customer</option>
            </select> -->
            <div style="width:320px;text-align:center;margin-left:auto;margin-right:auto;">
              <input type="search" placeholder="Search Customer Number/Name" class="form-control float-left searchInput" @keyup.enter="searchCustomer()" style="width:250px;" v-model="searchValue" />
              <CButton size="sm" color="info" class="searchButton" @click="searchCustomer()">Search</CButton>
            </div>
          </div>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader>
          Ship To Table
          <!-- <CButton size="sm" style="float:right;" color="success" @click="addModal = true">Add Ship To</CButton> -->
        </CCardHeader>
        <CCardBody>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <CDataTable
            :items="items"
            :fields="fields"
            column-filter
            table-filter
            :items-per-page="10"
            pagination
            v-if="!searchLoading"
          >
          <!-- <template #show="{item}">
            <td>
              <CButton size="sm" color="primary" @click="show( item.program_id )">Show</CButton>
            </td>
          </template> -->
          <template #edit="{item}">
            <td>
              <CButton size="sm" color="primary" @click="edit( item )">Edit</CButton>
            </td>
          </template>
          <!-- <template #delete="{item}">
            <td>
              <CButton size="sm" v-if="you!=item.id" color="danger" @click="deleteUser( item.id )">Delete</CButton>
            </td>
          </template> -->
        </CDataTable>
        <small-loader v-else></small-loader>
        </CCardBody>
      </CCard>
      </transition>

      <CModal
        title="Add Style"
        :show.sync="addModal"
      >
        <CForm>
          <CInput
            :lazy="false"
            :value.sync="form.ship_to_number"
            placeholder="Ship To Number"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="form.customer_number"
            placeholder="Customer Number"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="form.customer_name"
            placeholder="Customer Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="form.ship_name"
            placeholder="Ship to Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="form.ship_address"
            placeholder="Address"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="form.ship_city"
            placeholder="City"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <!-- <CInput
            :lazy="false"
            :value.sync="form.ship_state"
            placeholder="State"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          /> -->
          <v-select 
            v-model="form.ship_state" 
            v-if="states"
            :options="states"
            placeholder="Select State"
          />
          <CInput
            :lazy="false"
            :value.sync="form.ship_zip"
            placeholder="Zip Code"
            class="pt-3"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <!-- <CInput
            :lazy="false"
            :value.sync="form.ship_country"
            placeholder="Country"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          /> -->
          <v-select 
            v-model="form.ship_country"
            :options="['United States']"
            placeholder="Select Country"
          />
        </CForm>
        <template #footer>
          <CButton @click="addModal = false, reset()" color="danger">Cancel</CButton>
          <CButton @click="add()" color="success">Add</CButton>
        </template>
      </CModal>

      <CModal
        title="Edit Color"
        :show.sync="editModal"
      >
        <CForm v-if="editForm">
          <CInput
            :lazy="false"
            label="Ship To Number"
            disabled="true"
            :value.sync="editForm.ship_to_number"
            placeholder="Ship To Number"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Customer Number"
            disabled="true"
            :value.sync="editForm.customer_number"
            placeholder="Customer Number"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Customer Name"
            disabled="true"
            :value.sync="editForm.customer_name"
            placeholder="Customer Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Ship Name"
            disabled="true"
            :value.sync="editForm.ship_name"
            placeholder="Ship to Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Ship To Email"
            :value.sync="editForm.email"
            placeholder="Ship To Email"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Internal ID"
            v-if="$store.state.user.menu_array.indexOf('csr_admin') > -1"
            :value.sync="editForm.internal_id"
            placeholder="NetSuite Internal ID"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div class="float-left col-sm-12 mt-3 p-0" v-if="$store.state.user.menu_array.indexOf('csr_admin') > -1 || $store.state.user.menu_array.indexOf('csr') > -1">
              <label>Disabled?</label>
              <div>
                <CButton size="sm" @click="editForm.disabled = 1" :color="editForm.disabled === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="editForm.disabled = 0" style="margin-left:5px;" :color="editForm.disabled === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>
          <!-- <CInput
            :lazy="false"
            :value.sync="editForm.ship_address"
            placeholder="Address"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="editForm.ship_city"
            placeholder="City"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="editForm.ship_zip"
            placeholder="Zip Code"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="editForm.ship_state"
            placeholder="State"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="editForm.ship_country"
            placeholder="Country"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          /> -->
        </CForm>
        <template #footer>
          <CButton @click="editModal = false, resetEdit()" color="danger">Cancel</CButton>
          <CButton @click="save()" color="success">Save</CButton>
        </template>
      </CModal>
    </CCol>
  </CRow>
</template>

<script>
var methods = {}

methods.searchCustomer = function () {
  this.searchLoading = true
  // this.items = ''
  const postData = {
    customer_number: this.searchValue
  }
  var self = this
  axios.post( this.$apiAdress + '/api/searchCustomerShipTos?token=' + localStorage.getItem("api_token"), postData)
  .then(function (response) {
    console.log(response)
      self.items = response.data
    self.searchLoading = false
  }).catch(function (error) {
    console.log(error)
  });
}

methods.getData = function () {
  let self = this
  axios.post( this.$apiAdress + '/api/admin/ship_to/getAll?token=' + localStorage.getItem("api_token"))
  .then(function (response) {
    console.log(response)
    self.items = response.data
  }).catch(function (error) {
    console.log(error)
    self.$store.commit('axios_error', response)
  });
}

methods.reset = function () {
  this.form = this.getForm()
}

methods.resetEdit = function () {
  this.editModal = null
}

methods.edit = function (val) {
  // this.$router.push({ path: '/styles/' + val + '/edit' })
  this.editForm = val
  this.editModal = true
}

methods.save = function () {
  let self = this
  axios.post(this.$apiAdress + '/api/ship_to/update?token=' + localStorage.getItem('api_token'), self.editForm)
  .then(function (response) {
    self.editForm = null
    self.editModal = false
  }).catch(function (error) {
    console.log(error)
  })
}

methods.add = function () {
  let self = this;
  axios.post(   this.$apiAdress + '/api/admin/ship_to/store?token=' + localStorage.getItem("api_token"),
    self.form
  )
  .then(function (response) {
      console.log(response)
      self.items.push(response.data)
      self.form = self.getForm()
      self.addModal = false
  }).catch(function (error) {
    console.log(error)
    self.$store.commit('axios_error', error)
  });
}

methods.getForm = function () {
  return {
    ship_to_number: '',
    customer_number: '',
    customer_name: '',
    ship_name: '',
    ship_address: '',
    ship_city: '',
    ship_zip: '',
    ship_country: '',
    ship_state: ''
  }
}

export default {
  name: 'ShipToTable',
  data() {
    return {
      items: [],
      searchValue: '',
      searchLoading: false,
      fields: [
        'ship_to_number',
        'customer_number',
        'ship_name',
        'email',
        'internal_id',
        'edit'
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      addModal: false,
      form: this.getForm(),
      editForm: null,
      editModal: false,
      states: [
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming"
      ]
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  methods: methods,
  mounted: function(){
    // this.getData()
  }
}
</script>
